document.addEventListener('DOMContentLoaded', function() {
  function replaceBuyItNow() {
    var buttons = document.querySelectorAll('.shopify-payment-button__button--unbranded');
    buttons.forEach(function(btn) {
      if (btn.innerText.trim() !== 'PORUČIVANJE') {
        btn.innerText = 'PORUČIVANJE';
      }
    });
  }
  
  replaceBuyItNow();
  // Ponovi nakon kratkog delay-a jer se dugme učitava async
  setTimeout(replaceBuyItNow, 1000);
  setTimeout(replaceBuyItNow, 2000);
});
// Dinamički progress bar za besplatnu dostavu
function updateFreeShippingBar() {
  const threshold = 4000;
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const total = cart.total_price / 100;
      const remaining = threshold - total;
      let progress = (total / threshold) * 100;
      if (progress > 100) progress = 100;

      const bar = document.querySelector('.free-shipping-bar');
      if (!bar) return;

      const progressFill = bar.querySelector('div > div');
      const text = bar.querySelector('p');

      if (progressFill) progressFill.style.width = progress + '%';

      if (text) {
        if (remaining > 0) {
          text.innerHTML = 'Još <strong>' + Math.ceil(remaining) + ' RSD</strong> do <strong>besplatne dostave</strong> 🚚';
        } else {
          text.innerHTML = '✅ Čestitamo! Ostvarili ste <strong>besplatnu dostavu</strong>!';
          text.style.color = '#2e7d32';
        }
      }
    });
}

// Osluškuj promene u korpi
document.addEventListener('DOMContentLoaded', updateFreeShippingBar);
document.addEventListener('cart:updated', updateFreeShippingBar);

// Za Dawn/Pro temu koja koristi custom events
document.addEventListener('change', function(e) {
  if (e.target.classList.contains('quantity__input')) {
    setTimeout(updateFreeShippingBar, 500);
  }
});
